import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import ConsumerAccountProperties from './ConsumerAccountProperties';
import EnterpriseAccountProperties from './EnterpriseAccountProperties';

class AccountSummaryDetails extends Component {

  static contextTypes = {
    ngUser: PropTypes.object,
  };

  static propTypes = {
    accountSummary: PropTypes.object,
    isEditing: PropTypes.bool.isRequired,
  }

  defaultProps = {
    isEditing: false,
  };

  render() {
    const { ngUser } = this.context;
    const { accentColor, isEditing, accountSummary, enableEditMode, onSave } = this.props;
    const borderDisabled = !isEditing ? `2px solid ${accentColor}` : '2px solid #FFFFFF';
    const theme = createMuiTheme({
      palette: {
        primary: { 500: accentColor },
      },
    });
    const AccountPropsComponent = ngUser.isConsumer ? ConsumerAccountProperties : EnterpriseAccountProperties;

    return (
      <div className="display-flex full-width" style={{ border: borderDisabled }}>
        <ThemeProvider theme={theme}>
          <AccountPropsComponent
            accountSummary={accountSummary}
            accentColor={accentColor}
            enableEditMode={enableEditMode}
            onSave={onSave}
            isEditing={isEditing}/>
        </ThemeProvider>
      </div>
    );
  }
}

export default connect()(AccountSummaryDetails);